webpackJsonp([144509272382183],{

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.innerWrapperStyle = exports.contactTitleStyle = exports.contactContentStyle = exports.contactColumnStyle = exports.contactWrapStyle = exports.cardsSectionStyle = exports.cardsWrapStyle = exports.textStyle = exports.titleStyle = undefined;
	
	var _css;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '24px'
	}));
	
	var textStyle = exports.textStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: '800px',
		marginBottom: '15px'
	}));
	
	var cardsWrapStyle = /*#__PURE__*/exports.cardsWrapStyle = (0, _emotion.css)({
		position: 'relative',
	
		'&:after': {
			position: 'absolute',
			top: '0',
			left: '0',
			borderRadius: '0 8px 8px 0',
			width: '80%',
			height: 'calc(100% - 25px)',
			background: '#f6f6f6',
			content: '" "',
			display: 'block'
		}
	});
	
	var cardsSectionStyle = exports.cardsSectionStyle = (0, _emotion.cx)((0, _globalStyles.cardSection)(), /*#__PURE__*/(0, _emotion.css)({
		position: 'relative',
		zIndex: '2',
		top: '-50px'
	}));
	
	var contactWrapStyle = /*#__PURE__*/exports.contactWrapStyle = (0, _emotion.css)({
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'top',
		margin: '20px 0 40px 0'
	});
	
	var contactColumnStyle = exports.contactColumnStyle = (0, _emotion.cx)((0, _globalStyles.contentSection)('#fff'), /*#__PURE__*/(0, _emotion.css)((_css = {
		width: '50%'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		width: '100%'
	}, _css)));
	
	var contactContentStyle = exports.contactContentStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '39px',
		maxWidth: '355px'
	}));
	
	var contactTitleStyle = exports.contactTitleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '24px'
	}));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px'
	});

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _socialIcons = __webpack_require__(172);
	
	var _colourManager = __webpack_require__(173);
	
	var _getInvolved = __webpack_require__(1060);
	
	var _cards = __webpack_require__(17);
	
	var _arrowLink = __webpack_require__(52);
	
	var _colouredCard = __webpack_require__(61);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetInvolvedPage = function (_React$PureComponent) {
		_inherits(GetInvolvedPage, _React$PureComponent);
	
		function GetInvolvedPage() {
			_classCallCheck(this, GetInvolvedPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		GetInvolvedPage.prototype.render = function render() {
			var _ref;
	
			var pageSettings = this.props.data.page.edges[0].node;
	
			return _react2.default.createElement(
				'div',
				{ className: _getInvolved.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.heading }),
					_react2.default.createElement('meta', { name: 'description', content: 'Get involved in supporting the lives of Australians living with, or affected by an eating disorder. You can get involved by donating or holding a fundraiser, by volunteering your time or finding employment in the eating disorder sector.' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'Get involved in supporting the lives of Australians living with, or affected by an eating disorder. You can get involved by donating or holding a fundraiser, by volunteering your time or finding employment in the eating disorder sector.' })
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _getInvolved.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _getInvolved.titleStyle },
								pageSettings.heading
							)
						),
						_react2.default.createElement('div', { className: _getInvolved.textStyle, dangerouslySetInnerHTML: { __html: pageSettings.body } })
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _getInvolved.cardsWrapStyle },
					_react2.default.createElement(
						'div',
						{ className: _getInvolved.innerWrapperStyle },
						_react2.default.createElement(
							'section',
							{ className: _getInvolved.cardsSectionStyle },
							_react2.default.createElement(
								_cards.Cards,
								{
									columns: 4,
									scrollable: false,
									columnsAt: (_ref = {}, _ref['min-width: ' + _globalStyles.mobileMinWidthBreakpoint] = 1, _ref['min-width: ' + _globalStyles.tabletPortraitMinWidthBreakpoint] = 2, _ref['min-width: ' + _globalStyles.tabletLandscapeMinWidthBreakpoint] = 4, _ref)
								},
								pageSettings.tiles.map(function (tile, i) {
									return _react2.default.createElement(_colouredCard.ColouredCard, {
										id: i,
										key: i,
										background: (0, _colourManager.descriptionToHex)(tile.colour),
										to: tile.link_destination,
										title: tile.heading,
										body: tile.body,
										minHeight: 276,
										arrow: true
									});
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#fff', 0) },
					_react2.default.createElement(
						'div',
						{ className: _getInvolved.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _getInvolved.contactWrapStyle },
							_react2.default.createElement(
								'div',
								{ className: _getInvolved.contactColumnStyle },
								_react2.default.createElement(
									'header',
									null,
									_react2.default.createElement(
										'h1',
										{ className: _getInvolved.contactTitleStyle },
										pageSettings.spread_the_word_heading
									)
								),
								_react2.default.createElement('div', {
									className: _getInvolved.contactContentStyle,
									dangerouslySetInnerHTML: { __html: pageSettings.spread_the_word_body }
								}),
								_react2.default.createElement(_socialIcons.SocialIcons, { mode: 'share', width: 50, inline: true })
							),
							_react2.default.createElement(
								'div',
								{ className: _getInvolved.contactColumnStyle },
								_react2.default.createElement(
									'header',
									null,
									_react2.default.createElement(
										'h1',
										{ className: _getInvolved.contactTitleStyle },
										pageSettings.get_in_touch_heading
									)
								),
								_react2.default.createElement('div', {
									className: _getInvolved.contactContentStyle,
									dangerouslySetInnerHTML: { __html: pageSettings.get_in_touch_body }
								}),
								_react2.default.createElement(
									_arrowLink.ArrowLink,
									{ to: pageSettings.get_in_touch_link_url },
									pageSettings.get_in_touch_link_text
								)
							)
						)
					)
				)
			);
		};
	
		return GetInvolvedPage;
	}(_react2.default.PureComponent);
	
	GetInvolvedPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						tiles: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							heading: _propTypes2.default.string,
							body: _propTypes2.default.string,
							link_destination: _propTypes2.default.string,
							colour: _propTypes2.default.string
						})),
						spread_the_word_heading: _propTypes2.default.string.isRequired,
						spread_the_word_body: _propTypes2.default.string.isRequired,
						get_in_touch_heading: _propTypes2.default.string.isRequired,
						get_in_touch_body: _propTypes2.default.string.isRequired,
						get_in_touch_link_text: _propTypes2.default.string.isRequired,
						get_in_touch_link_url: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = GetInvolvedPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-get-involved-index-js-f8ec19a8525e8d78cb75.js